module.exports = __webpack_public_path__ + "img/36.4c48826f.jpg";